import CONSTANTS from "../Constants/Constants";

export const flight_offer_object_from_duffel_data = (data) => {

}

/**
 * 
 * @param {Object} data 
 * @returns Duffel Checkout Object
 */
export const return_duffel_checkout_object = (data) => {
    if(!data)
        return
    let passengers=[];
    for(let pp=0;pp<data?.passengers?.length;pp++){
        passengers.push({
            "title": "",
            "phone_number": "",
            ...(
                data.passengers[pp]?.infant_passenger_id 
                    ? { "infant_passenger_id": data.passengers[pp]?.infant_passenger_id } 
                    : {}
            ),
            "identity_documents": [
                {
                    "unique_identifier": "",
                    "type": "",
                    "issuing_country_code": "",
                    "expires_on": ""
                }
            ],
            "id": data.passengers[pp]?.id,
            "given_name": data.passengers[pp]?.given_name || "",
            "gender": "",
            "type": data.passengers[pp]?.type || "",
            "family_name": data.passengers[pp]?.family_name || "",
            "email": "",
            "born_on": ""
        });
    }

    return {
        "type": "instant",
        "services": [],
        "selected_offers": [
          data.id,
        ],
        "payments": [
          {
            "type": CONSTANTS.duffel_checkout.payment.types.balance,
            "currency": data.total_currency,
            "amount": data.total_amount
          }
        ],
        "passengers": passengers,
        "metadata": {}
    }
}

/**
 * @param {Object} obj
 * @returns Default Log Object from duffel's order completed details
 */
export const return_duffel_booked_flight_log_object = (obj) => {
    let tt="one-way";
    if(obj.slices.length===2){
        tt="round-trip"
    }else if(obj.slices.length>2){
        tt="multi-city"
    }
    return {
        API_PROVIDER: "Duffel",
        BOOKING_ID: obj?.id,
        TYPE: "Flight",
        AIRLINE_NAME: obj?.owner?.name,
        AIRLINE_IATA: obj?.owner?.iata_code,
        TRIP_TYPE: tt,
        CABIN_TYPE: obj?.slices[0].segments[0].passengers[0].cabin_class,
        TRAVELERS: obj.passengers,
        ORIGIN_AIRPORT_NAME: obj?.slices[0].origin.name,
        ORIGIN_AIRPORT_IATA: obj?.slices[0].origin.iata_code,
        ORIGIN_CITY_NAME: obj?.slices[0].origin.city_name,
        DESTINATION_AIRPORT_NAME: ((obj.slices.length>1) ? 
                                        obj?.slices[(obj.slices.length-1)].origin.name : 
                                        obj.slices[(obj.slices.length-1)].destination.name
                                ),
        DESTINATION_AIRPORT_IATA: ((obj?.slices.length>1) ? 
                                        obj?.slices[(obj.slices.length-1)].origin.iata_code :
                                        obj?.slices[(obj.slices.length-1)].destination.iata_code
                                ),
        DESTINATION_CITY_NAME: ((obj?.slices?.length>1) ? 
                                    obj?.slices[(obj.slices.length-1)].origin.city_name :
                                    obj?.slices[(obj.slices.length-1)].destination.city_name
                            ),
        DEPARTURE_DATE: obj?.slices[0].segments[0].departing_at,
        TOTAL_AMOUNT: obj?.total_amount,
        TOTAL_CURRENCY: obj?.total_currency,
        RETURN_DATE: obj?.slices[(obj.slices.length-1)].segments[(obj.slices[[(obj.slices.length-1)]].segments.length-1)].arriving_at,
    }
}

/**
 * 
 */
export const return_duffel_booked_flight_order_object = (obj) => {
    return obj;
}

/**
 * 
 * @returns 
 */
export const return_duffel_confirmed_order_example = () => {
    return {
        "type": "instant",
        "total_currency": "USD",
        "total_amount": "404.59",
        "tax_currency": "USD",
        "tax_amount": "61.72",
        "synced_at": "2023-11-23T14:37:38Z",
        "slices": [
            {
                "segments": [
                    {
                        "passengers": [
                            {
                                "seat": null,
                                "passenger_id": "pas_0000Ac6K7OtiPbsp1NTVxK",
                                "cabin_class_marketing_name": "Economy",
                                "cabin_class": "economy",
                                "baggages": [
                                    {
                                        "type": "checked",
                                        "quantity": 1
                                    },
                                    {
                                        "type": "carry_on",
                                        "quantity": 1
                                    }
                                ]
                            }
                        ],
                        "origin_terminal": "2",
                        "origin": {
                            "type": "airport",
                            "time_zone": "Africa/Accra",
                            "name": "Kotoka International Airport",
                            "longitude": -0.167454,
                            "latitude": 5.605642,
                            "id": "arp_acc_gh",
                            "icao_code": "DGAA",
                            "iata_country_code": "GH",
                            "iata_code": "ACC",
                            "iata_city_code": "ACC",
                            "city_name": "Accra",
                            "city": null
                        },
                        "operating_carrier_flight_number": "10",
                        "operating_carrier": {
                            "name": "American Airlines",
                            "logo_symbol_url": "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/AA.svg",
                            "logo_lockup_url": "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/AA.svg",
                            "id": "arl_00009VME7DAGiJjwomhv32",
                            "iata_code": "AA",
                            "conditions_of_carriage_url": "https://www.aa.com/i18n/customer-service/support/conditions-of-carriage.jsp"
                        },
                        "marketing_carrier_flight_number": "10",
                        "marketing_carrier": {
                            "name": "American Airlines",
                            "logo_symbol_url": "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/AA.svg",
                            "logo_lockup_url": "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/AA.svg",
                            "id": "arl_00009VME7DAGiJjwomhv32",
                            "iata_code": "AA",
                            "conditions_of_carriage_url": "https://www.aa.com/i18n/customer-service/support/conditions-of-carriage.jsp"
                        },
                        "id": "seg_0000Ac6K7P3dohp5WA7RQW",
                        "duration": "PT11H32M",
                        "distance": "8221.392679809798",
                        "destination_terminal": "1",
                        "destination": {
                            "type": "airport",
                            "time_zone": "America/New_York",
                            "name": "John F. Kennedy International Airport",
                            "longitude": -73.778519,
                            "latitude": 40.640556,
                            "id": "arp_jfk_us",
                            "icao_code": "KJFK",
                            "iata_country_code": "US",
                            "iata_code": "JFK",
                            "iata_city_code": "NYC",
                            "city_name": "New York",
                            "city": {
                                "type": "city",
                                "time_zone": null,
                                "name": "New York",
                                "longitude": null,
                                "latitude": null,
                                "id": "cit_nyc_us",
                                "icao_code": null,
                                "iata_country_code": "US",
                                "iata_code": "NYC",
                                "iata_city_code": "NYC",
                                "city_name": null
                            }
                        },
                        "departure_terminal": "2",
                        "departure_datetime": "2023-11-29T21:40:00",
                        "departing_at": "2023-11-29T21:40:00",
                        "arriving_at": "2023-11-30T04:12:00",
                        "arrival_terminal": "1",
                        "arrival_datetime": "2023-11-30T04:12:00",
                        "aircraft": {
                            "name": "Airbus A319",
                            "id": "arc_00009VMF8AgpV5sdO0xXAn",
                            "iata_code": "319"
                        }
                    }
                ],
                "origin_type": "airport",
                "origin": {
                    "type": "airport",
                    "time_zone": "Africa/Accra",
                    "name": "Kotoka International Airport",
                    "longitude": -0.167454,
                    "latitude": 5.605642,
                    "id": "arp_acc_gh",
                    "icao_code": "DGAA",
                    "iata_country_code": "GH",
                    "iata_code": "ACC",
                    "iata_city_code": "ACC",
                    "city_name": "Accra",
                    "city": null
                },
                "id": "sli_0000Ac6KEffjaAdhv9NCr2",
                "fare_brand_name": "Basic",
                "duration": "PT11H32M",
                "destination_type": "airport",
                "destination": {
                    "type": "airport",
                    "time_zone": "America/New_York",
                    "name": "John F. Kennedy International Airport",
                    "longitude": -73.778519,
                    "latitude": 40.640556,
                    "id": "arp_jfk_us",
                    "icao_code": "KJFK",
                    "iata_country_code": "US",
                    "iata_code": "JFK",
                    "iata_city_code": "NYC",
                    "city_name": "New York",
                    "city": {
                        "type": "city",
                        "time_zone": null,
                        "name": "New York",
                        "longitude": null,
                        "latitude": null,
                        "id": "cit_nyc_us",
                        "icao_code": null,
                        "iata_country_code": "US",
                        "iata_code": "NYC",
                        "iata_city_code": "NYC",
                        "city_name": null
                    }
                },
                "conditions": {
                    "change_before_departure": {
                        "penalty_currency": null,
                        "penalty_amount": null,
                        "allowed": false
                    }
                },
                "changeable": true
            }
        ],
        "services": [],
        "payment_status": {
            "price_guarantee_expires_at": null,
            "payment_required_by": null,
            "paid_at": "2023-11-23T14:37:38Z",
            "awaiting_payment": false
        },
        "passengers": [
            {
                "type": "adult",
                "title": "mr",
                "phone_number": "+17327999546",
                "loyalty_programme_accounts": [],
                "infant_passenger_id": null,
                "id": "pas_0000Ac6K7OtiPbsp1NTVxK",
                "given_name": "Mohammed",
                "gender": "m",
                "family_name": "Adinan",
                "email": "m.adinan@yahoo.com",
                "born_on": "1992-03-23"
            }
        ],
        "owner": {
            "name": "American Airlines",
            "logo_symbol_url": "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/AA.svg",
            "logo_lockup_url": "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/AA.svg",
            "id": "arl_00009VME7DAGiJjwomhv32",
            "iata_code": "AA",
            "conditions_of_carriage_url": "https://www.aa.com/i18n/customer-service/support/conditions-of-carriage.jsp"
        },
        "metadata": {},
        "live_mode": false,
        "id": "ord_0000Ac6KEffNbUM7u3CvIm",
        "documents": [
            {
                "unique_identifier": "1",
                "type": "electronic_ticket",
                "passenger_ids": [
                    "pas_0000Ac6K7OtiPbsp1NTVxK"
                ]
            }
        ],
        "created_at": "2023-11-23T14:37:38.485807Z",
        "content": "managed",
        "conditions": {
            "refund_before_departure": {
                "penalty_currency": "GBP",
                "penalty_amount": "50.00",
                "allowed": true
            },
            "change_before_departure": {
                "penalty_currency": null,
                "penalty_amount": null,
                "allowed": false
            }
        },
        "changes": [],
        "cancelled_at": null,
        "cancellation": null,
        "booking_reference": "VXYP4X",
        "base_currency": "USD",
        "base_amount": "342.87",
        "available_actions": [
            "cancel",
            "change",
            "update"
        ],
        "airline_initiated_changes": []
    }
}